/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

type Props = {
  block: EditorialTextBlock,
};

const Render = ({ block }: Props) => {
  function createMarkup() {
    return { __html: block.content };
  }

  if (block.content) {
    return <div dangerouslySetInnerHTML={createMarkup()} />;
  }

  return <Message icon="info" header="Aucun contenu spécifié" />;
};

export default Render;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/text/Render.js